import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import './ClothScreen.css';

import { Products } from '../../appojo/models/Products';
import {
  requestApi, RequestModel, ResponseModel,
  EndPointPaths, printConsole, AssetConstants,
  RouteConstants, SessionKeys, clientConfig,
  i18n, strings, checkLoginData
} from '../../utils/CommonImports';
import { ProductType } from '../../appojo/models/ProductType';
import { Gender } from '../../appojo/models/Gender';
import { MobileFilterRequest } from '../../appojo/requestmodel/MobileFilterRequest';
import { Customers } from '../../appojo/models/Customers';


const ClothScreen = (props) => {
  let navigate = useNavigate();
  const [stateValue, setStateValue] = useState({
    languageName: '',
    users: null,
    productObj: new Products(),
    previousMenu: RouteConstants.DashBoard,
  });
  const [showLoader, setShowLoader] = useState(false);
  const [cartQuantity, setCartQuantity] = useState(props.cartQuantity != null ? props.cartQuantity : 0);
  const [isConnected, setIsConnected] = useState(true);
  const [initialState, setInitialState] = useState(true);
  const [dummyData, setDummyData] = useState(true);
  // const [similarProducts, setSimilarProducts] = useState(new Products());
  const [productCtegroryData, setProductCtegroryData] = useState(new MobileFilterRequest());

  useEffect(() => {
    getSessionValues()
      .then((productType) => {
        if (productType != null) {
          getAllCategoryProduct(productType);
        }
        if (checkLoginData(stateValue.users)) {
          getCustomerCartCount();
        }
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }, 0)
      });

    return () => {

    }
  }, [props]);


  const getSessionValues = async () => {
    let users = JSON.parse(sessionStorage.getItem(SessionKeys.loginObj));
    let previousMenu = sessionStorage.getItem(SessionKeys.previousMenu);
    let language = sessionStorage.getItem(SessionKeys.languageName);
    if (language == null) {
      language = clientConfig.defaultLanguage;
    }
    const productType = new ProductType();
    productType.id = "5db99b8bc14de04080b4d298";
    productType.productTypeName = "CLOTHING";
    productType.productTypeName_fr = "VÊTEMENTS";
    productType.productTypeImage = "https://160.bizmobia.com/digilook/images/80026418.png";
    i18n.changeLanguage(language);
    stateValue.languageName = language;
    stateValue.previousMenu = previousMenu;
    stateValue.users = users;
    setStateValue(stateValue);
    return productType;
  }

  const getAllCategoryProduct = async (productType: ProductType) => {
    try {
      setShowLoader(true);
      const request = new RequestModel();
      const filterRequest = new MobileFilterRequest();
      const gender = new Gender();
      gender.genderName = 'All';

      filterRequest.productTypeObj = productType;
      filterRequest.genderObj = gender;
      request.userId = '809957651';
      request.reqObject = filterRequest;
      // request.date = filterRequest;
      const responseResult = await requestApi(request, EndPointPaths.getproductbyproducttype, isConnected);
      if (responseResult.status === 0) {
        const responsemodel: ResponseModel = responseResult.data;
        if (responsemodel.statusCode === 0) {
          setProductCtegroryData(responsemodel.respObject)
          setInitialState(false);
          // const dashboardResponse = new MobileDashboardResponse(responsemodel.respObject);
        } else if (responsemodel.statusCode === 1) {
          // ToastMessage.showError(strings(responsemodel.message));
        } else if (responsemodel.statusCode === 2) {
          // ToastMessage.showError(strings(responsemodel.message));
        } else {
          // ToastMessage.showError(strings('plsetry'));
        }
      } else if (responseResult.status === 1) {
        printConsole("API dash Error 1: " + responseResult.data)
      } else if (responseResult.status === 2) {
        printConsole("API dash Error 2: " + responseResult.data)
      } else {
        printConsole("API dash Error 3: " + responseResult.data)
      }
    } catch (err) {
      printConsole("Try Error dash: " + err);
    } finally {
      setShowLoader(false);
    }
  }
  const getCustomerCartCount = async () => {
    try {
      const request = new RequestModel();
      const customer = new Customers();
      customer.id = stateValue.users.id;
      request.reqObject = customer;
      const responseResult = await requestApi(request, EndPointPaths.getcustomercartcount, isConnected);
      printConsole("CART:cat " + JSON.stringify(responseResult));
      if (responseResult.status === 0) {
        const responsemodel: ResponseModel = responseResult.data;
        if (responsemodel.statusCode === 0) {
          setCartQuantity(responsemodel.respObject.cartCount);
        } else if (responsemodel.statusCode === 2 || responsemodel.statusCode === 1) {
          setCartQuantity(0);
        } else if (responsemodel.statusCode === 25) {
          props.navigation.navigate(RouteConstants.LoginScreen);
        } else {
          setCartQuantity(0);
        }
      } else {
        setCartQuantity(0);
      }
    } catch (err) {
      setCartQuantity(0);
    }
  }
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: false,
    centerPadding: '100px',
    accessibility: false,
    arrows: true,
    'responsive': [{
      'breakpoint': 1600,
      'settings': {
        'slidesToShow': 1,
        'slidesToScroll': 1,
      }
    },
    {
      'breakpoint': 1000,
      'settings': {
        'slidesToShow': 1,
        'slidesToScroll': 1,
        centerPadding: '100px',
      }
    }, {
      'breakpoint': 600,
      'settings': {
        'slidesToShow': 1,
        'slidesToScroll': 1,
        centerPadding: '50px',
      }
    },
    {
      'breakpoint': 550,
      'settings': {
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'centerMode': false,
      }
    },
    {
      'breakpoint': 322,
      'settings': {
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'centerMode': false,
      }
    },
    ],
  };

  const sliderList = [
    { imageUrl: 'https://cdn.shopify.com/s/files/1/0495/6199/3384/files/Flash_Sale_bnner.jpg?v=1642490252' },
    { imageUrl: 'https://1.bp.blogspot.com/-qRM5vGXTRyc/XZYC5XHoOTI/AAAAAAAACJQ/7TGNnTon4ZsUVRj0842WGeFgicmdDyKBwCEwYBhgL/s1600/banner2.jpg' },
    { imageUrl: 'https://thedapperday.com/wp-content/uploads/2021/11/shirts-3.jpg' },
  ];

  const buyNowClicked = (product: any) => {

    console.log(JSON.stringify(product));
    saveStorage(RouteConstants.DashBoard, SessionKeys.previousMenu, 'string');
    saveStorage(product, SessionKeys.productObj, 'object');

    console.log('jsx: ' + JSON.parse(sessionStorage.getItem(SessionKeys.productObj)))
    navigate("../productdetails");
  }
  const saveStorage = async (value: any, key: any, type: any) => {
    if (type === "object") {
      // console.log('JSON.stringify(value))
      sessionStorage.setItem(key, JSON.stringify(value));
    } else if (type === "remove") {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value)
    }
  }

  return (
    < >

      <section className='mt-2' style={{ height: "auto", width: "100%", }}>
        <Slider {...settings} >
          {sliderList.map((clientObj, index) => {
            return (
              <div key={index} style={{ backgroundColor: 'transparent', height: 'auto', width: '100%', }}>
                <img alt="slider" className='sliderBanner' src={clientObj.imageUrl} />
              </div>

            )
          })}
        </Slider>

      </section>


      <section className='mt-2' style={{ backgroundColor: 'white' }}>

        <div className='container-fluid mt-5 responsiveContainer' >
          <div className='row'>
            <div className='col-sm-3 mt-3 remove' >
              <div className='container-fluid' style={{ backgroundColor: 'transparent' }}>
                {/* <button onClick={onClickBtn} className="accordion">Section 1</button>
                <div className="panel">
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                </div> */}
                <div style={{ border: '1px solid #ccc', borderRadius: '8px' }}>
                  <div style={{ padding: '5px 8px' }}>
                    <h5 style={{ borderBottom: '1px solid #ccc', padding: '5px' }}>Fliter</h5>
                  </div>
                  <div style={{ padding: '5px 8px' }}>
                    <input type="radio" id="html" name="fav_language" value="HTML" />
                    <label htmlFor="html"> &nbsp;&nbsp;Today</label>
                  </div>
                  <div style={{ padding: '5px 8px' }}>
                    <input type="radio" id="html" name="fav_language" value="HTML" />
                    <label htmlFor="html"> &nbsp;&nbsp;This Week</label>
                  </div>
                </div>

                <div className='mt-2' style={{ border: '1px solid #ccc', borderRadius: '8px' }}>
                  <div style={{ padding: '5px 8px' }}>
                    <h5 style={{ borderBottom: '1px solid #ccc', padding: '5px' }}>Category</h5>
                  </div>
                  <div style={{ padding: '5px 8px' }}>
                    <input type="radio" id="html" name="fav_language" value="HTML" />
                    <label htmlFor="html"> &nbsp;&nbsp;Events</label>
                  </div>
                  <div style={{ padding: '5px 8px' }}>
                    <input type="radio" id="html" name="fav_language" value="HTML" />
                    <label htmlFor="html"> &nbsp;&nbsp;Sports</label>
                  </div>
                  <div style={{ padding: '5px 8px' }}>
                    <input type="radio" id="html" name="fav_language" value="HTML" />
                    <label htmlFor="html"> &nbsp;&nbsp;Movies</label>
                  </div>
                  <div style={{ padding: '5px 8px' }}>
                    <input type="radio" id="html" name="fav_language" value="HTML" />
                    <label htmlFor="html"> &nbsp;&nbsp;Bus</label>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-sm-12 col-md-9 ' style={{ maxHeight: '650px', overflowY: 'scroll' }} >
              <div>
                <button className='filterBtn' data-bs-toggle="modal" data-bs-target="#exampleModal">Filter</button>
              </div>
              {productCtegroryData.productsList ?
                <div className='row'>
                  {productCtegroryData.productsList.map((clientObj, index) => {
                    return (
                      <div key={index} className='col-6 col-xl-4 col-lg-4 col-md-4 col-sm-4 mt-3 col-xs-4 responsiveBox'>
                        <div className=" eventsBox">
                          <div className="box">
                            <img alt="box" className='boxImage' onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = AssetConstants.defaultimg;
                            }}
                              src={clientObj.productThumbNailImage !== null ? clientObj.productThumbNailImage : AssetConstants.defaultimg}
                              style={{ borderRadius: '4px' }} />
                            <div className="content">
                              <div className="wrap">
                                <a onClick={() => buyNowClicked(clientObj)}>
                                  <button className='button' >Buy Now</button>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div>
                            <h6 className='oneLineText' style={{ color: '#000' }}>{clientObj.title}</h6>
                            <h6 className='oneLineText' style={{ color: '#000', fontSize: '13px' }}>{clientObj.shortDescription}</h6>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
                : null}

            </div>
          </div>
        </div>
      </section>


      <section>
        {/* <!-- Button trigger modal --> */}
        {/* <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Launch demo modal
</button> */}

        {/* <!-- Modal --> */}
        <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Modal title</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className='container-fluid' style={{ backgroundColor: 'transparent' }}>

                  <div style={{ border: '1px solid #ccc', borderRadius: '8px' }}>
                    <div style={{ padding: '5px 8px' }}>
                      <h5 style={{ borderBottom: '1px solid #ccc', padding: '5px' }}>Fliter</h5>
                    </div>
                    <div style={{ padding: '5px 8px' }}>
                      <input type="radio" id="html" name="fav_language" value="HTML" />
                      <label htmlFor="html"> &nbsp;&nbsp;Today</label>
                    </div>
                    <div style={{ padding: '5px 8px' }}>
                      <input type="radio" id="html" name="fav_language" value="HTML" />
                      <label htmlFor="html"> &nbsp;&nbsp;This Week</label>
                    </div>
                  </div>

                  <div className='mt-2' style={{ border: '1px solid #ccc', borderRadius: '8px' }}>
                    <div style={{ padding: '5px 8px' }}>
                      <h5 style={{ borderBottom: '1px solid #ccc', padding: '5px' }}>Category</h5>
                    </div>
                    <div style={{ padding: '5px 8px' }}>
                      <input type="radio" id="html" name="fav_language" value="HTML" />
                      <label htmlFor="html"> &nbsp;&nbsp;Events</label>
                    </div>
                    <div style={{ padding: '5px 8px' }}>
                      <input type="radio" id="html" name="fav_language" value="HTML" />
                      <label htmlFor="html"> &nbsp;&nbsp;Sports</label>
                    </div>
                    <div style={{ padding: '5px 8px' }}>
                      <input type="radio" id="html" name="fav_language" value="HTML" />
                      <label htmlFor="html"> &nbsp;&nbsp;Movies</label>
                    </div>
                    <div style={{ padding: '5px 8px' }}>
                      <input type="radio" id="html" name="fav_language" value="HTML" />
                      <label htmlFor="html"> &nbsp;&nbsp;Bus</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export default ClothScreen;